import { Component, Inject, Optional } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import { BaseComponent } from '../../../../../shared/base-components/base.component';
import { ValidationModel } from '../../../../../shared/models/validation-results/validation.model';
import { OwnershipService } from '../../../../../titleregistration/services/ownership.service';
import { VehicleWatchContactModel } from '../../../../models/vehicle-watch-contact.model';

export class WatchYourVehicleData {
    constructor(
        public vehicleWatchContactModel: VehicleWatchContactModel,
        public vehicleId: number
    ) { }
}

@Component({
    selector: 'watch-your-car-modal',
    templateUrl: './watch-your-car-modal.html'

})
export class WatchYourCarModalComponent extends BaseComponent {
    public watchYourCarForm: UntypedFormGroup;
    public validationModel: ValidationModel = new ValidationModel([]);

    private vehicleWatchContactModel: VehicleWatchContactModel;
    private vehicleId: number;

    constructor(
        private fb: UntypedFormBuilder,
        private dialogRef: MatDialogRef<WatchYourCarModalComponent>,
        private _ownershipService: OwnershipService,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: WatchYourVehicleData
    ) {
        super();
    }

    public ngOnInit(): void {
        this.vehicleWatchContactModel = new VehicleWatchContactModel();
        this.vehicleWatchContactModel.phone1 = this.data.vehicleWatchContactModel.phone1;
        this.vehicleWatchContactModel.phone2 = this.data.vehicleWatchContactModel.phone2;
        this.vehicleId = this.data.vehicleId;

        this.watchYourCarForm = this.fb.group({
            'phone1': [this.vehicleWatchContactModel.phone1, Validators.required],
            'phone2': [this.vehicleWatchContactModel.phone2],
        });
    }

    /**
     * Dismisses the modal.
     */
    public cancel(): void {
        this.dialogRef.close();
    }

    /**
     * Dismisses the modal and raises an event
     */
    public save(): void {
        if (this.watchYourCarForm.valid) {
            this._ownershipService.updateVehicleWatchContact(this.getModel(), this.vehicleId).subscribe(
                r => {
                    this.dialogRef.close(true);
                },
                err => {
                    this.validationModel = new ValidationModel(err);
                }
            );
        }
    }

    /**
     * Creates an object which represents the vehicle-watch contact
     * @returns the object which represents the vehicle-watch contact
     */
    private getModel(): VehicleWatchContactModel {
        const model = Object.assign(new VehicleWatchContactModel(), this.vehicleWatchContactModel);

        model.phone1 = this.watchYourCarForm.get('phone1').value;
        model.phone2 = this.watchYourCarForm.get('phone2').value;

        return model;
    }
}
